import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowLeft, ArrowUpRight } from "@phosphor-icons/react";

export default function BlogDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/blogs/${slug}`).then((r) => setPost(r.data)).catch(() => setError("Post not found"));
  }, [slug]);

  if (error) return <div className="max-w-3xl mx-auto py-24 px-6 text-ink/60">{error}</div>;
  if (!post) return <div className="max-w-3xl mx-auto py-24 px-6 text-ink/60">Loading…</div>;

  return (
    <article className="max-w-3xl mx-auto px-6 md:px-12 py-16">
      <Link to="/blog" className="inline-flex items-center label-mono hover:text-ink" data-testid="blog-back">
        <ArrowLeft className="w-3.5 h-3.5 mr-1.5" weight="bold" /> All entries
      </Link>
      <div className="mt-10 label-mono">{(post.tags || []).join(" · ").toUpperCase()}</div>
      <h1 className="mt-4 font-display font-black text-5xl md:text-6xl tracking-tightest text-ink leading-[1]">
        {post.title}
      </h1>
      <div className="mt-6 label-mono">
        {post.author} · {post.published_at ? new Date(post.published_at).toLocaleDateString() : ""}
      </div>
      {post.cover_image_url && (
        <img src={post.cover_image_url} alt="" className="mt-10 border border-rule w-full" />
      )}
      <div className="mt-10 text-ink/80 leading-[1.75] whitespace-pre-line text-[17px]">
        {post.body}
      </div>
      {post.source_url && (
        <div className="mt-12 border border-rule bg-white p-6">
          <div className="label-mono">Source · {post.source_name}</div>
          <a href={post.source_url} target="_blank" rel="noopener noreferrer"
            className="mt-2 inline-flex items-center font-medium text-ink hover:underline">
            Read full article <ArrowUpRight className="w-4 h-4 ml-1.5" weight="bold" />
          </a>
        </div>
      )}
    </article>
  );
}
